import React, { type FC, type OptionHTMLAttributes } from 'react';
import { cn } from '../../utils/ui';

export interface OptionProps extends Omit<OptionHTMLAttributes<HTMLOptionElement>, 'className'> {
    className?: string;
}

const Option: FC<OptionProps> = props => {
    const { className, children, ...rest } = props;

    function getClassName(): string {
        return 'py-2 text-gray-950 dark:text-white bg-white dark:bg-gray-900';
    }

    return (
        <option className={cn(getClassName(), className)} {...rest}>
            {children}
        </option>
    );
};

export default Option;
